import {FaWhatsapp} from 'react-icons/fa';
import SafeIcon from './SafeIcon';

const WA = 'https://wa.me/919876543210?text=Hi%20Aurelle!%20I%20would%20like%20to%20know%20more.';

function WhatsAppFloat() {
  return (
    <a href={WA} target="_blank" rel="noreferrer" aria-label="Contact us on WhatsApp" className="wa-float">
      <span className="wa-float-icon"><SafeIcon icon={FaWhatsapp} /></span>
      <span className="wa-float-label">Contact Us</span>
    </a>
  );
}

export default WhatsAppFloat;
